var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeyboardArrowLeft24Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon/hardware/keyboard_arrow_left_24px",
    d: "M0.795079 1.41L5.37508 6L0.795078 10.59L2.20508 12L8.20508 6L2.20508 -5.24537e-07L0.795079 1.41Z",
    fill: "#FB263B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyboardArrowLeft24Px);
export default __webpack_public_path__ + "static/media/keyboard_arrow_left_24px.aeb0e9baa34dfe46ddab296ab914e823.svg";
export { ForwardRef as ReactComponent };